import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Restringe una ruta al equipo de Meetzy. Se usa en /tickets-legacy, que es el
 * sistema de tickets antiguo sobre ClickHouse: los clientes usan /tickets, que
 * es el portal contra ClientFlow.
 *
 * Esto es una puerta de UI, no de seguridad: el filtrado real de tickets lo
 * hace el backend a partir del token verificado.
 */
@Injectable({ providedIn: 'root' })
export class MeetzyStaffGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    // En un refresco directo de la URL, currentUser todavía puede ser null
    // cuando corre el guard, así que se espera al primer estado de Firebase.
    const user = await new Promise<any>((resolve) => {
      const unsubscribe = this.authService.auth.onAuthStateChanged((u) => {
        unsubscribe();
        resolve(u);
      });
    });

    const email = (user?.email || '').toLowerCase();
    if (email.endsWith('@meetzy.io')) return true;

    this.router.navigate(['/tickets']);
    return false;
  }
}
